var map = {
	"./1.jpg": 528,
	"./10.jpg": 496,
	"./11.png": 656,
	"./2.jpg": 241,
	"./3.jpg": 636,
	"./4.jpg": 157,
	"./5.jpg": 675,
	"./6.jpg": 402,
	"./7.png": 443,
	"./8.jpg": 321,
	"./9.jpg": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;